export default "__VITE_ASSET__BcizL6Pe__"